import styled from 'styled-components';
import { Box, Text } from '@rsos/components/capstone/base';

export const Container = styled(Box).attrs({
  border: 'solid 1px',
  borderColor: 'heavyLineOutline',
  borderRadius: '5px',
  width: 1,
  height: '225px',
  horizontal: true,
  overflow: 'auto',
})``;

export const FormContainer = styled(Container).attrs({})`
  background-color: ${({ theme }) => theme.colors.foreground};
`;

export const Selector = styled(Box).attrs({
  width: '55%',
  borderRight: 'solid 1px',
  borderColor: 'heavyLineOutline',
  py: '13px',
  height: '100%',
  overflow: 'scroll',
})``;

export const DescriptionContainer = styled(Box).attrs(() => ({
  width: '45%',
  color: 'secondaryText',
  justify: 'center',
  align: 'center',
}))``;
export const EmptyContainer = styled(Box).attrs(() => ({
  width: '45%',
  justify: 'center',
  align: 'center',
}))``;

export const DescriptionWrapper = styled(Box).attrs(({ visible }) => ({
  p: '18px 13px 13px 13px',
  display: visible ? 'flex' : 'none',
  width: '100%',
  height: '100%',
}))``;

export const Description = styled(Text).attrs({
  width: 1,
  size: 'normal',
})``;
export const Name = styled(Text).attrs({
  color: 'primaryText',
  size: 'normal',
})``;

export const NameContainer = styled(Box).attrs({
  minHeight: '40px',
  maxHeight: '40px',
  justify: 'start',
  horizontal: true,
  align: 'center',
})`
  cursor: pointer;
  background-color: ${({ selected, theme }) =>
    selected ? theme.colors.highlights : 'inherit'};
  &:hover {
    background-color: ${({ theme }) => theme.colors.foreground};
  }
`;

export const IconWrapper = styled(Box).attrs(() => {})`
  visibility: ${({ selected }) => (selected ? 'visible' : 'hidden')};
`;
